// Mock Auth Utility

export const login = async (email, password) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (email && password) {
        // Simulate successful login
        localStorage.setItem('auth_token', 'mock_token_123');
        resolve({
          user: {
            name: 'Demo User',
            email: email,
            role: 'Admin'
          }
        });
      } else {
        reject(new Error('Invalid credentials'));
      }
    }, 1000);
  });
};

export const logout = () => {
  localStorage.removeItem('auth_token');
};

export const clearAuthData = () => {
  localStorage.removeItem('auth_token');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('auth_token');
};
